'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var WidgetUi = (0, _immutable.Record)({
  mobile: false,
  open: false,
  hideWelcomeMessage: false,
  domain: null,
  url: null
});

exports.default = WidgetUi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/WidgetUi.js
// module id = 124
// module chunks = 0 1